<h2 mat-dialog-title>Update Tutorials</h2>

<mat-dialog-content>
    <form [formGroup]="tutorialForm" class="tutorial-form">
        <textarea class="tutorial-textarea"
                  formControlName="content" 
                  placeholder=""></textarea>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!tutorialForm.valid || isSubmitting">
        <span *ngIf="!isSubmitting">OK</span>
        <span *ngIf="isSubmitting">Updating...</span>
    </button>
</mat-dialog-actions>